import { lazy, Suspense, type ReactNode } from 'react';
import { Redirect, type RouteComponentProps } from 'react-router-dom';

import { Spinner } from 'app/components/customers/Spinner';

import { ChunkErrorBoundary, FallbackWrapper } from './ChunkErrorBoundary';

const Cadastro = lazy(() => import('app/pages/Cadastro'));
const CadastroV2 = lazy(() => import('app/pages/CadastroV2'));

function RegisterChunkBoundary({ children }: { children: ReactNode }) {
  return (
    <ChunkErrorBoundary flow="register_route" message="Não foi possível carregar o cadastro.">
      {children}
    </ChunkErrorBoundary>
  );
}

function RouteLoading() {
  return (
    <FallbackWrapper>
      <Spinner />
    </FallbackWrapper>
  );
}

export function RegisterRoute(props: Record<string, unknown>) {
  return (
    <RegisterChunkBoundary>
      <Suspense fallback={<RouteLoading />}>
        <Cadastro {...props} />
      </Suspense>
    </RegisterChunkBoundary>
  );
}

export function CadastroV2Route(props: Record<string, unknown>) {
  return (
    <RegisterChunkBoundary>
      <Suspense fallback={<RouteLoading />}>
        <CadastroV2 {...props} />
      </Suspense>
    </RegisterChunkBoundary>
  );
}

export function RegisterCepRedirect({ match, location }: RouteComponentProps<{ redirect?: string }>) {
  const { redirect } = match.params;
  return <Redirect to={redirect ? `/register/${redirect}${location.search}` : `/register${location.search}`} />;
}
